import React from 'react';

function StartupHeader() {
  return (
    <header>
      <nav>
        <h1 className='mb-4 text-2xl'>Teachble Productivity Bundle</h1>
        <ul>
          <li><a href="#home">Home</a></li>
          <li><a href="#documents">Documents</a></li>
          <li><a href="#about">About</a></li>
          <li><a href="#pricing">Pricing</a></li>
        </ul>
      </nav>
    </header>
  );
}

export default StartupHeader;